var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThirdBlockWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1120,
    height: 713,
    viewBox: "0 0 1120 713",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0123 282.025C129.546 312.843 178.199 25.1182 235.932 46.1657C295.734 67.9674 104.309 495.891 168.366 519.244C229.881 541.67 345.774 128.932 407.403 151.4C466.766 173.042 303.111 525.645 367.389 549.079C428.585 571.389 517.661 234.318 578.931 256.655C637.52 278.014 492.495 551.966 566.356 578.893C640.217 605.82 682.279 347.109 742.751 369.155C799.929 390 698.136 585.019 751.85 604.601C797.455 621.227 839.38 447.797 889.352 466.015C939.324 484.233 869.491 625.323 913.459 641.352C953.374 655.903 979.544 539.249 1015.32 552.292C1051.1 565.335 996.011 648.539 1041.63 665.171C1052.67 669.195 1060.96 667.019 1074.92 656.186",
    stroke: "url(#paint0_linear_1787_44159)",
    strokeWidth: 90,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1787_44159",
    x1: 1092.71,
    y1: 607.373,
    x2: 448.45,
    y2: 372.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdBlockWave);
export default __webpack_public_path__ + "static/media/third_block_wave.e801626e7cfd76f2b4c573603f8cb929.svg";
export { ForwardRef as ReactComponent };